<template>
  <div v-if="controls" class="refapp-video__controls">
    <button
      ref="playbackControls"
      type="button"
      data-refapp-tagging-target="playbackControls"
      :data-refapp-tagging-extras="videoControlsExtras"
      class="refapp-video__controls-button"
      :class="{
        'refapp-video__controls-playback': true,
        'refapp-video__controls-playback--paused': !autoplay,
      }"
      :aria-label="a11yLabels[autoplay ? 'pause' : 'play']"
      @click="(e) => $emit('playback', e.target)"
    ></button>
    <button
      ref="audioControls"
      type="button"
      data-refapp-tagging-target="audioControls"
      :data-refapp-tagging-extras="videoControlsExtras"
      class="refapp-video__controls-button"
      :class="{
        'refapp-video__controls-audio': true,
        'refapp-video__controls-audio--muted': muted,
      }"
      :aria-label="a11yLabels[muted ? 'unmute' : 'mute']"
      @click="(e) => $emit('audio', e.target)"
    ></button>
  </div>
</template>

<script>
export default {
  name: 'refapp-video-controls',
  inject: ['muted', 'autoplay', 'controls', 'a11yLabels', 'heading'],
  emits: ['playback', 'audio'],
  computed: {
    videoControlsExtras() {
      return JSON.stringify({
        eventLabel: this.heading.toLocaleLowerCase() || '',
        video_title: this.heading.toLocaleLowerCase() || '',
      });
    },
  },
};
</script>
